import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0c2c2350"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2c2350')) {
      api.createRecord('0c2c2350', component.options)
    } else {
      api.reload('0c2c2350', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=0c2c2350", function () {
      api.rerender('0c2c2350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Dashboard.vue"
export default component.exports